import MuiTooltip, { type TooltipProps } from "@mui/material/Tooltip";

export type { TooltipProps };

export function Tooltip({ arrow = true, ...props }: TooltipProps) {
  return <MuiTooltip arrow={arrow} {...props} />;
}
